import { Observable } from 'rxjs';
import { TimeSlotBookingModel, TimeSlotMetadata } from '../model';

export abstract class BookingConfirmationService {
    abstract confirmBooking(slot: TimeSlotBookingModel, metadata: TimeSlotMetadata): Observable<unknown>;
}
